export default __webpack_public_path__ + "static/media/i202jk.162e243a.webp";